module.exports = __webpack_public_path__ + "static/media/d2-class@2x.74aa62f1.png";